import { AxiosError } from "axios";

import { api } from "@/lib/axios";

type Answer = {
	id: string;
	content: string;
	likes: number;
	logged_user_liked: boolean;
	user_name: string;
	user_id: string;
	user_image: string | null;
	created_at: string;
};

export type Comment = {
	id: string;
	content: string;
	likes: number;
	logged_user_liked: boolean;
	user_name: string;
	user_id: string;
	user_image: string | null;
	created_at: string;
	answers: Answer[];
};

interface showCommentsParams {
	lessonId: string;
	sortBy: "created_at-DESC" | "created_at-ASC" | "likes-DESC";
	perPage: number;
}

export async function showComments(
	params: Partial<showCommentsParams>,
): Promise<
	| {
			status: "success";
			data: Comment[];
			lastPage: number;
			page: number;
			perPage: number;
			total: number;
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get(`/comment`, {
			params,
		});

		return {
			status: "success",
			data: data.data.data,
			lastPage: data.data.meta.lastPage,
			page: data.data.meta.page,
			perPage: data.data.meta.perPage,
			total: data.data.meta.total,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
